import type * as core from '../../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.submonitoring.core',
    'resource:data.dimensions.subawardMonitoringActivities.entities.activity.attributes.alwaysRecommend',
    'resource:data.dimensions.subawardMonitoringActivities.entities.activity',
    'resource:data.dimensions.subawardMonitoringActivities',
    'resource:data.dimensions.subawardMonitoringActivityAssignments.entities.entry.attributes.activity',
    'resource:data.dimensions.subawardMonitoringActivityAssignments.entities.entry.attributes.subaward',
    'resource:data.dimensions.subawardMonitoringActivityAssignments.entities.entry',
    'resource:data.dimensions.subawardMonitoringActivityAssignments',
    'resource:data.dimensions.subawards.snapshots.subawardRiskSurvey',
    'resource:data.dimensions.subawardTermsAndConditionAssignments.entities.entry.attributes.subaward',
    'resource:data.dimensions.subawardTermsAndConditionAssignments.entities.entry.attributes.tc',
    'resource:data.dimensions.subawardTermsAndConditionAssignments.entities.entry',
    'resource:data.dimensions.subawardTermsAndConditionAssignments',
    'resource:data.dimensions.subawardTermsAndConditionMonitorActivities.entities.entry.attributes.activity',
    'resource:data.dimensions.subawardTermsAndConditionMonitorActivities.entities.entry.attributes.tc',
    'resource:data.dimensions.subawardTermsAndConditionMonitorActivities.entities.entry',
    'resource:data.dimensions.subawardTermsAndConditionMonitorActivities',
    'resource:data.dimensions.subawardTermsAndConditions.entities.tc.attributes.riskThreshold',
    'resource:data.dimensions.subawardTermsAndConditions.entities.tc',
    'resource:data.dimensions.subawardTermsAndConditions',
    'resource:data.enums.subawardRisk',
    'resource:data.enums.subawardRisk.entries.high',
    'resource:data.enums.subawardRisk.entries.low',
    'resource:data.enums.subawardRisk.entries.medium',
  ],
  description: 'TODO',
  name: 'Subrecipients',
} as const satisfies core.quiver.Package
